import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from "./HomePage"; // Your homepage or feature selection
import MessageDisplay from "./MessageDisplay";// Import your widget component
import PoemDisplay from "./PoemDisplay";// Import your widget component
import MemoryDisplay from "./MemoryDisplay";// Import your widget component
import RoastGenerator from "./RoastContainer";// Import your widget component
import RoastDisplay from "./RoastDisplay";// Import your widget component
import WeddingVowsContainer from "./WeddingVowsContainer";
import WeddingVowsDisplay from "./WeddingVowsDisplay";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/message/:id" element={<MessageDisplay />} />
        <Route path="/poem/:id" element={<PoemDisplay />} />
        <Route path="/memory/:id" element={<MemoryDisplay />} />
        <Route path="/roast-me" element= {<RoastGenerator/>} />
        <Route path="/roast/:id" element= {<RoastDisplay/>} />
        <Route path="/wedding-vows-generator" element= {<WeddingVowsContainer/>} />
        <Route path="/wedding-vows/:id" element= {<WeddingVowsDisplay/>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
